export function googleAnalytics(action, variable1, variable2, variable3) {
    if (typeof ga === "function") {
        ga(action, variable1, variable2, variable3);
        return true;
    }
    return false;
}
export function googleAnalyticsParams() {
    if (typeof ga === "function" && ga.getAll) {
        return ga.getAll();
    }
    return null;
}
export function googleAnalyticsLegacy(action, commandArray) {
    if (typeof _gaq === "object") {
        _gaq[action](commandArray);
        return true;
    }
    return false;
}
export function googleTagManager(action, subAction, data, src) {
    const googleTagType = detectGoogleTagScript(src);
    if (googleTagType === "dataLayer") {
        //sending Event with datalayer.push()
        return dataLayerPush(subAction, data);
    }
    else if (typeof gtag === "function") {
        gtag(action, subAction, data);
        return true;
    }
    return false;
}
function detectGoogleTagScript(src) {
    if ((localStorage.getItem("FS_TAG_MANAGER_PROVIDER") === '1' && typeof window.dataLayer === "object") || src === "v-next-ssr") {
        return "dataLayer";
    }
    const scripts = document.getElementsByTagName('script');
    let gtagPresent = false;
    let gtmPresent = false;
    for (let i = 0; i < scripts.length; i++) {
        const src = scripts[i].getAttribute('src');
        if (src) {
            if (src.includes('/gtm.js')) {
                return "gtag";
            }
            else if (src.includes('/gtag/js')) {
                gtagPresent = true;
            }
        }
    }
    return gtmPresent ? "dataLayer" : "gtag";
}
export function dataLayerPush(action, data) {
    var _a, _b;
    if (action === "view_search_results") {
        (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(Object.assign({ event: action, _clear: true, "eventCategory": "Ecommerce", "eventAction": action }, data));
        return true;
    }
    (_b = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({
        event: action,
        ecommerce: data,
        _clear: true,
        "eventCategory": "Ecommerce",
        "eventAction": action,
    });
    return true;
}
//# sourceMappingURL=googleAnalytics.js.map